(function () {
  'use strict';

  var api = window.BellissimaRoyalPawtraits || {};
  window.BellissimaRoyalPawtraits = api;
  var SAVE_ENDPOINT = '/apps/image-composer/save?shop=bellisima-uk.myshopify.com';
  var STORE_PATH = '/s/files/1/0284/5284/7688/files/';
  var MAX_BYTES = 8 * 1024 * 1024;
  var TOTAL_TIMEOUT = 60000;
  var FONT_FAMILY = '"Iowan Old Style", "Palatino Linotype", Palatino, Georgia, serif';

  function failure(message) { return new Error(message || 'Your portrait could not be saved. Please try again.'); }

  function remaining(deadline, maximum) {
    var duration = Math.min(maximum, deadline - Date.now());
    if (duration <= 0) throw failure('Saving your portrait took too long. Please try again.');
    return duration;
  }

  function sourceIsAllowed(value) {
    if (/^data:image\/(?:png|jpeg|webp);base64,/i.test(value)) return true;
    try {
      var url = new URL(value);
      return url.protocol === 'https:' && url.hostname === 'cdn.shopify.com' && !url.username && !url.password &&
        url.pathname.indexOf(STORE_PATH) === 0 && /\/(?:gemini_|dpc_)[^/]+\.(?:png|jpe?g|webp)$/i.test(url.pathname);
    } catch (_) { return false; }
  }

  function verifiedUrl(value, label) {
    try {
      var url = new URL(value);
      var filename = url.pathname.slice(STORE_PATH.length);
      if (url.protocol !== 'https:' || url.hostname !== 'cdn.shopify.com' || url.username || url.password || url.hash ||
          url.pathname.indexOf(STORE_PATH) !== 0 || !/^dpc_[a-zA-Z0-9_-]+\.png$/.test(filename) ||
          filename.indexOf('dpc_' + label + '_') !== 0) throw failure();
      return url.href;
    } catch (_) { throw failure('Your saved portrait could not be verified. Please try again.'); }
  }

  function loadImage(source, timeout) {
    return new Promise(function (resolve, reject) {
      var image = new Image();
      var timer = setTimeout(function () {
        image.onload = image.onerror = null;
        image.src = '';
        reject(failure('Your portrait image took too long to load. Please try again.'));
      }, timeout);
      image.crossOrigin = 'anonymous';
      image.onload = function () {
        clearTimeout(timer);
        image.onload = image.onerror = null;
        if (!image.naturalWidth || !image.naturalHeight) reject(failure('Your portrait image could not be read.'));
        else resolve(image);
      };
      image.onerror = function () {
        clearTimeout(timer);
        image.onload = image.onerror = null;
        reject(failure('Your portrait image could not load. Please try again.'));
      };
      image.src = source;
    });
  }

  function roundedRectangle(context, x, y, width, height, radius) {
    radius = Math.min(radius, width / 2, height / 2);
    context.beginPath();
    context.moveTo(x + radius, y);
    context.lineTo(x + width - radius, y);
    context.quadraticCurveTo(x + width, y, x + width, y + radius);
    context.lineTo(x + width, y + height - radius);
    context.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
    context.lineTo(x + radius, y + height);
    context.quadraticCurveTo(x, y + height, x, y + height - radius);
    context.lineTo(x, y + radius);
    context.quadraticCurveTo(x, y, x + radius, y);
    context.closePath();
  }

  function drawGilt(context, width, height, rail) {
    var unit = width / 210;
    var gold = context.createLinearGradient(0, 0, width, 0);
    [[0, '#6e4c12'], [.12, '#d9b25a'], [.22, '#f7e3a0'], [.4, '#b8862c'], [.6, '#e8c873'], [.8, '#8a6418'], [.92, '#d4a94c'], [1, '#5e400e']]
      .forEach(function (stop) { gold.addColorStop(stop[0], stop[1]); });
    context.fillStyle = gold;
    context.fillRect(0, 0, width, height);
    context.save();
    context.beginPath();
    context.rect(0, 0, width, height);
    context.rect(rail, rail, width - rail * 2, height - rail * 2);
    context.clip('evenodd');
    var light = context.createLinearGradient(0, 0, 0, height);
    light.addColorStop(0, 'rgba(255,255,255,.38)');
    light.addColorStop(.18, 'rgba(255,255,255,0)');
    light.addColorStop(.8, 'rgba(0,0,0,0)');
    light.addColorStop(1, 'rgba(0,0,0,.32)');
    context.fillStyle = light;
    context.fillRect(0, 0, width, height);
    context.strokeStyle = 'rgba(255,255,255,.09)';
    context.lineWidth = 2 * unit;
    for (var diagonal = -height; diagonal < width; diagonal += 7 * unit) {
      context.beginPath();
      context.moveTo(diagonal, 0);
      context.lineTo(diagonal + height, height);
      context.stroke();
    }
    context.restore();
    [[1, '#4a330a'], [3, '#f3d98a'], [5, '#a57a26'], [7, '#5a3d0c']].forEach(function (bevel) {
      var inset = bevel[0] * unit;
      context.strokeStyle = bevel[1];
      context.lineWidth = unit;
      context.strokeRect(inset, inset, width - inset * 2, height - inset * 2);
    });
    context.strokeStyle = '#e9cd7d';
    context.lineWidth = 3 * unit;
    context.strokeRect(rail - 2 * unit, rail - 2 * unit, width - rail * 2 + 4 * unit, height - rail * 2 + 4 * unit);
  }

  function drawPlaque(context, width, height, rail, text, hasGilt) {
    var unit = width / 210;
    var plaqueHeight = hasGilt ? Math.min(rail * .92, height * .055) : Math.min(width * .078, height * .06);
    var fontSize = Math.min(width * .047, plaqueHeight * .68);
    var horizontalPadding = width * .035;
    var maxWidth = width * .72;
    context.font = '500 ' + fontSize + 'px ' + FONT_FAMILY;
    var measured = context.measureText(text).width;
    if (measured > maxWidth - horizontalPadding * 2) {
      fontSize *= (maxWidth - horizontalPadding * 2) / measured;
      context.font = '500 ' + fontSize + 'px ' + FONT_FAMILY;
      measured = context.measureText(text).width;
    }
    var plaqueWidth = Math.min(maxWidth, Math.max(width * .19, measured + horizontalPadding * 2));
    var x = (width - plaqueWidth) / 2;
    var centreY = hasGilt ? height - rail / 2 : height * .9;
    var y = centreY - plaqueHeight / 2;
    context.save();
    roundedRectangle(context, x, y, plaqueWidth, plaqueHeight, 2 * unit);
    var gold = context.createLinearGradient(0, y, 0, y + plaqueHeight);
    gold.addColorStop(0, '#f3df9c');
    gold.addColorStop(.55, '#c9a24a');
    gold.addColorStop(1, '#a57d2a');
    context.fillStyle = gold;
    context.shadowColor = 'rgba(0,0,0,.4)';
    context.shadowBlur = 4 * unit;
    context.shadowOffsetY = 2 * unit;
    context.fill();
    context.shadowBlur = context.shadowOffsetY = 0;
    context.strokeStyle = '#8a6418';
    context.lineWidth = unit;
    context.stroke();
    roundedRectangle(context, x + 2 * unit, y + 2 * unit, plaqueWidth - 4 * unit, plaqueHeight - 4 * unit, unit);
    context.strokeStyle = '#f6e3a6';
    context.stroke();
    context.fillStyle = '#3a2608';
    context.textAlign = 'center';
    context.textBaseline = 'middle';
    context.font = '500 ' + fontSize + 'px ' + FONT_FAMILY;
    context.fillText(text, width / 2, centreY + fontSize * .055);
    context.restore();
  }

  function compose(image, state) {
    var sourceWidth = image.naturalWidth;
    var sourceHeight = image.naturalHeight;
    var width = Math.round(sourceHeight * 21 / 29.7);
    var height = image.naturalHeight;
    if (sourceWidth < 64 || sourceHeight < 64 || width < 64 || width > 16384 || height > 16384 || width * height > 40000000) {
      throw failure('This portrait size could not be prepared. Please try again.');
    }
    var canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    var context = canvas.getContext('2d');
    if (!context) throw failure('Your portrait could not be prepared on this device.');
    context.imageSmoothingEnabled = true;
    context.imageSmoothingQuality = 'high';
    context.fillStyle = '#2c201a';
    context.fillRect(0, 0, width, height);
    var marginX = Math.ceil(width * .05);
    var marginY = Math.ceil(height * .05);
    var frameWidth = width - marginX * 2;
    var frameHeight = height - marginY * 2;
    var rail = Math.min(frameWidth * .085, frameHeight * .085);
    if (state.goldFrame) {
      context.save();
      context.translate(marginX, marginY);
      drawGilt(context, frameWidth, frameHeight, rail);
      context.fillStyle = '#2c201a';
      context.fillRect(rail, rail, frameWidth - rail * 2, frameHeight - rail * 2);
      // Contain the complete source within the opening; the printed rail never crops the pet.
      var scale = Math.min((frameWidth - rail * 2) / sourceWidth, (frameHeight - rail * 2) / sourceHeight, 1);
      var artWidth = sourceWidth * scale;
      var artHeight = sourceHeight * scale;
      context.drawImage(image, (frameWidth - artWidth) / 2, (frameHeight - artHeight) / 2, artWidth, artHeight);
      context.restore();
    } else {
      var plainScale = Math.min(width / sourceWidth, height / sourceHeight, 1);
      var plainWidth = sourceWidth * plainScale;
      var plainHeight = sourceHeight * plainScale;
      context.drawImage(image, (width - plainWidth) / 2, (height - plainHeight) / 2, plainWidth, plainHeight);
    }
    var name = String(state.petName || '').trim();
    if (name) {
      var text = [String(state.prefix || '').trim(), name].filter(Boolean).join(' ');
      if (state.goldFrame) {
        context.save();
        context.translate(marginX, marginY);
        drawPlaque(context, frameWidth, frameHeight, rail, text, true);
        context.restore();
      } else drawPlaque(context, width, height, rail, text, false);
    }
    return canvas;
  }

  function encode(canvas, deadline) {
    return new Promise(function (resolve, reject) {
      var timer = setTimeout(function () { reject(failure('Your portrait took too long to prepare.')); }, remaining(deadline, 15000));
      try {
        canvas.toBlob(function (blob) {
          clearTimeout(timer);
          if (!blob || blob.type !== 'image/png') { reject(failure('Your portrait image could not be prepared.')); return; }
          if (blob.size > MAX_BYTES) { reject(failure('This portrait is too large to save. Please try another photo.')); return; }
          try {
            var reader = new FileReader();
            var readTimer = setTimeout(function () { reader.abort(); reject(failure('Your portrait took too long to prepare.')); }, remaining(deadline, 10000));
            reader.onerror = function () { clearTimeout(readTimer); reject(failure('Your portrait image could not be read.')); };
            reader.onload = function () {
              clearTimeout(readTimer);
              var encoded = String(reader.result || '');
              if (!/^data:image\/png;base64,/.test(encoded)) reject(failure('Your portrait image could not be prepared.'));
              else resolve(encoded.slice(encoded.indexOf(',') + 1));
            };
            reader.readAsDataURL(blob);
          } catch (error) { reject(error); }
        }, 'image/png');
      } catch (_) {
        clearTimeout(timer);
        reject(failure('Your portrait image could not be prepared. Please try again.'));
      }
    });
  }

  function assertCurrent(state) {
    if (typeof api.state !== 'function') throw failure('Please choose your portrait again.');
    var current = api.state();
    if (!current || current.slug !== state.slug || String(current.petName || '').trim() !== String(state.petName || '').trim() ||
        !!current.custom !== !!state.custom || String(current.customPerson || '').trim() !== String(state.customPerson || '').trim() ||
        (current.species === 'cat' ? 'cat' : 'dog') !== (state.species === 'cat' ? 'cat' : 'dog') ||
        current.goldFrame !== state.goldFrame || String(current.prefix || '').trim() !== String(state.prefix || '').trim()) {
      throw failure('Your portrait options changed. Please create a new preview.');
    }
  }

  // The on-page example uses the same printed composition without saving or generating anything.
  api.composePreview = function (image, state) { return compose(image, state); };

  var printArtworkCache = new Map();
  var PRINT_CROP_VERSION = 'outer-margin-5-v1';
  function cropPrintArtwork(source) {
    var width = source.naturalWidth || source.width;
    var height = source.naturalHeight || source.height;
    var marginX = Math.ceil(width * .05);
    var marginY = Math.ceil(height * .05);
    var cropped = document.createElement('canvas');
    cropped.width = width - marginX * 2;
    cropped.height = height - marginY * 2;
    var context = cropped.getContext('2d');
    if (!context || cropped.width < 1 || cropped.height < 1) throw failure('Your print could not be prepared. Please try again.');
    context.drawImage(source,marginX,marginY,cropped.width,cropped.height,0,0,cropped.width,cropped.height);
    return cropped;
  }
  api.cropPrintPreview = cropPrintArtwork;

  api.preparePrintArtwork = function (original, state) {
    if (!state || state.goldFrame !== true) return Promise.resolve(original);
    var captured = Object.assign({},state);
    var master;
    try {
      master = new URL(original);
      if (master.protocol !== 'https:' || master.hostname !== 'cdn.shopify.com' || master.username || master.password || master.hash ||
          master.pathname.indexOf(STORE_PATH) !== 0 || !sourceIsAllowed(master.href) || !/^[a-zA-Z0-9-]+$/.test(captured.slug || '')) throw failure();
      assertCurrent(captured);
    } catch (_) { return Promise.reject(failure('Your print details could not be verified. Please create a new preview.')); }
    var key = master.href + '|' + PRINT_CROP_VERSION;
    if (printArtworkCache.has(key)) return printArtworkCache.get(key).then(function (url) { assertCurrent(captured); return url; });
    var task = (async function () {
      var deadline = Date.now() + TOTAL_TIMEOUT;
      var source = await loadImage(master.href,remaining(deadline,15000));
      var cropped = cropPrintArtwork(source);
      var b64 = await encode(cropped,deadline);
      assertCurrent(captured);
      var label = 'royal-pawtraits-print-' + captured.slug;
      var abort = new AbortController();
      var timeout = setTimeout(function () { abort.abort(); },remaining(deadline,45000));
      var saved;
      try {
        var response = await fetch(SAVE_ENDPOINT,{
          method:'POST',credentials:'same-origin',cache:'no-store',signal:abort.signal,
          headers:{'Content-Type':'application/json'},
          body:JSON.stringify({b64:b64,mime:'image/png',meta:{
            label:label,fileName:label,source:'royal-pawtraits-print',productId:'16237349601658',
            masterUrl:master.href,cropVersion:PRINT_CROP_VERSION,
            portraitSlug:captured.slug,portraitDesign:captured.name,petName:captured.petName || '',
            custom:!!captured.custom,customPerson:captured.custom ? captured.customPerson : '',
            species:captured.species === 'cat' ? 'cat' : 'dog',
            exampleMode:captured.exampleMode || (captured.species === 'cat' ? 'cat' : 'dog'),
            prefix:captured.prefix || '',goldFrame:true,artStyle:captured.style || '',
            width:cropped.width,height:cropped.height
          }})
        });
        saved = await response.json().catch(function () { return null; });
        if (!response.ok || !saved || !saved.url) throw failure('Your print could not be saved. Please try again.');
      } catch (error) {
        if (error && error.name === 'AbortError') throw failure('Preparing your print took too long. Please try again.');
        throw error;
      } finally { clearTimeout(timeout); }
      var url = verifiedUrl(saved.url,label);
      var uploaded = await loadImage(url,remaining(deadline,15000));
      if (uploaded.naturalWidth !== cropped.width || uploaded.naturalHeight !== cropped.height) throw failure('Your saved print size could not be verified. Please try again.');
      assertCurrent(captured);
      return url;
    })().catch(function (error) {
      if (printArtworkCache.get(key) === task) printArtworkCache.delete(key);
      throw error;
    });
    printArtworkCache.set(key,task);
    return task;
  };

  async function finalizeArtwork(result, state) {
    var deadline = Date.now() + TOTAL_TIMEOUT;
    if (!result || typeof result.resultSrc !== 'string' || !sourceIsAllowed(result.resultSrc) || !state ||
        !/^[a-zA-Z0-9-]+$/.test(state.slug || '') || typeof state.goldFrame !== 'boolean' ||
        String(state.petName || '').trim().length > 18 || String(state.customPerson || '').trim().length > 100 ||
        (state.custom && !String(state.customPerson || '').trim()) ||
        /[\u0000-\u001f\u007f]/.test(String(state.petName || '') + String(state.prefix || '') + String(state.customPerson || ''))) {
      throw failure('Your portrait details could not be verified. Please create a new preview.');
    }
    assertCurrent(state);
    var source = await loadImage(result.resultSrc, remaining(deadline, 15000));
    var canvas = compose(source, state);
    var b64 = await encode(canvas, deadline);
    assertCurrent(state);
    var label = 'royal-pawtraits-' + state.slug;
    var abort = new AbortController();
    var timeout = setTimeout(function () { abort.abort(); }, remaining(deadline, 45000));
    var saved;
    try {
      var response = await fetch(SAVE_ENDPOINT, {
        method: 'POST', credentials: 'same-origin', cache: 'no-store', signal: abort.signal,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ b64: b64, mime: 'image/png', meta: {
          label: label, fileName: label, source: 'royal-pawtraits', productId: '16237349601658',
          portraitSlug: state.slug, portraitDesign: state.name, petName: state.petName || '',
          custom: !!state.custom, customPerson: state.custom ? state.customPerson : '',
          species: state.species === 'cat' ? 'cat' : 'dog',
          exampleMode: state.exampleMode === 'mixed' || state.exampleMode === 'dog' || state.exampleMode === 'cat' ? state.exampleMode : state.species === 'cat' ? 'cat' : 'dog',
          prefix: state.prefix || '', goldFrame: state.goldFrame, artStyle: state.style || '',
          width: canvas.width, height: canvas.height
        } })
      });
      saved = await response.json().catch(function () { return null; });
      if (!response.ok || !saved || !saved.url) throw failure('Your portrait could not be saved. Please try again.');
    } catch (error) {
      if (error && error.name === 'AbortError') throw failure('Saving your portrait took too long. Please try again.');
      throw error;
    } finally { clearTimeout(timeout); }
    var url = verifiedUrl(saved.url, label);
    var uploaded = await loadImage(url, remaining(deadline, 15000));
    if (uploaded.naturalWidth !== canvas.width || uploaded.naturalHeight !== canvas.height) {
      throw failure('Your saved portrait size could not be verified. Please try again.');
    }
    assertCurrent(state);
    return Object.assign({}, result, { resultSrc: url, hostedUrl: url, mimeType: 'image/png' });
  }

  var currentGeneration = null;
  var finalizeRevision = 0;
  var finalizing = false;

  function generationIdentity(state) {
    var image = String(state.image || '');
    try { if (image) image = new URL(image, location.href).href; } catch (_) {}
    return JSON.stringify([
      state.slug || '', state.name || '', state.brief || '', image,
      String(state.petName || '').trim(), String(state.prefix || '').trim(),
      !!state.custom, String(state.customPerson || '').trim(),
      state.species === 'cat' ? 'cat' : 'dog', state.style || ''
    ]);
  }

  function assertGeneration(generation, state) {
    assertCurrent(state);
    if (finalizing || currentGeneration !== generation ||
        generationIdentity(state) !== generation.identity ||
        generationIdentity(Object.assign({}, generation.state, api.state())) !== generation.identity) {
      throw failure('Your portrait changed. Please create a new preview.');
    }
  }

  api.finalize = async function (result, state) {
    var revision = ++finalizeRevision;
    var raw = Object.assign({}, result);
    var captured = Object.assign({}, state);
    finalizing = true;
    try {
      var finalized = await finalizeArtwork(raw, captured);
      assertCurrent(captured);
      if (revision !== finalizeRevision) throw failure('Your portrait changed. Please create a new preview.');
      currentGeneration = {
        raw: raw, state: captured, identity: generationIdentity(captured),
        renditions: new Map([[captured.goldFrame, Object.assign({}, finalized)]]),
        urls: new Set([finalized.resultSrc]), pending: new Map()
      };
      return finalized;
    } finally {
      if (revision === finalizeRevision) finalizing = false;
    }
  };

  api.reframe = function (originalHostedUrl, requestedState) {
    var generation = currentGeneration;
    if (!generation || typeof originalHostedUrl !== 'string' || !generation.urls.has(originalHostedUrl)) {
      return Promise.reject(failure('Changing the gold frame on this saved portrait needs its original session. Open that session or create a new preview.'));
    }
    var captured = Object.assign({}, generation.state, requestedState);
    try {
      if (!requestedState || typeof requestedState.goldFrame !== 'boolean') throw failure('Please choose the gold frame option again.');
      assertGeneration(generation, captured);
    } catch (error) { return Promise.reject(error); }
    var gold = captured.goldFrame;
    if (generation.renditions.has(gold)) {
      return Promise.resolve().then(function () {
        assertGeneration(generation, captured);
        return Object.assign({}, generation.renditions.get(gold));
      });
    }
    if (!generation.pending.has(gold)) {
      var task = finalizeArtwork(generation.raw, captured).then(function (finalized) {
        assertGeneration(generation, captured);
        generation.renditions.set(gold, Object.assign({}, finalized));
        generation.urls.add(finalized.resultSrc);
        return finalized;
      }).finally(function () {
        if (generation.pending.get(gold) === task) generation.pending.delete(gold);
      });
      generation.pending.set(gold, task);
    }
    return generation.pending.get(gold).then(function (finalized) {
      assertGeneration(generation, captured);
      return Object.assign({}, finalized);
    });
  };
})();
